module.exports = __webpack_public_path__ + "img/58.10.pH.e926f030.png";